import {RewardFeederMethods} from "./reward";
import {DiscountFeederMethods} from "./discount";

export const FeederMethods = {
  ...RewardFeederMethods,
  ...DiscountFeederMethods
};

export default FeederMethods;